// factory function, not to be confused with batws.js which is not (see module.fad.js)
define('lib/services/offers-service',['lib/rest'], function (RestAPI) {
  var spec = {
    host: '/offers-service',
    apis: {
      offers: {
        url: '/OFFERS/',
        calls: {
          all: {
            url: 'allOffers/',
            dataType: 'json',
            defaults: {
              pageSize: 9,
              startIndex: 0,
              lang: 'en'
            }
          },

          // document the reqs here
          byOfferId: {
            url: 'byOfferId/',
            dataType: 'json',
            defaults: {
              pageSize: 1,
              startIndex: 0,
              offerId: null,
              lang: 'en',
            }
          }
        }
      }
    }
  };

  return function (apiKey) {
    return new RestAPI(spec, { params: { key: apiKey } });
  };
});

